import React, { createContext, useContext } from 'react';

import { FormInstance } from 'antd';

import { COMMUNITY_CONTRACT_SELECTION_TYPE, CONTRACT_DISPLAY_TYPES } from '../../../../constants';

type CMASummaryContractsFilterType = {
  form?: FormInstance;
  contractDisplayType: number;
  contractSelectionType: number;
  communityContractSlugs: string[];
};

export const CMASummaryContractsFilterContext = createContext<CMASummaryContractsFilterType>({
  form: undefined,
  contractDisplayType: CONTRACT_DISPLAY_TYPES.EVERYONES_CONTRACTS,
  contractSelectionType: COMMUNITY_CONTRACT_SELECTION_TYPE.APPROXIMATE,
  communityContractSlugs: [],
});

export const useCMASummaryContractsFilterContext = () => useContext(CMASummaryContractsFilterContext);
